// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__X_MmG","copyright":"footer_copyright__mv9zS","navigation":"footer_navigation__GskGu","footer-logos":"footer_footer-logos__sMwIg"};